module.exports = __webpack_public_path__ + "media/images/expert__martina-moser-9dc0acc3aa5d0e4b12f58029c705d239.png";